import { render, staticRenderFns } from "./GiveawayPoints.vue?vue&type=template&id=903fb7c6&scoped=true&lang=pug&"
import script from "./GiveawayPoints.vue?vue&type=script&lang=js&"
export * from "./GiveawayPoints.vue?vue&type=script&lang=js&"
import style0 from "./GiveawayPoints.vue?vue&type=style&index=0&id=903fb7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903fb7c6",
  null
  
)

export default component.exports